document.addEventListener('DOMContentLoaded', () => {
  const containers$ = document.querySelectorAll('.hero-slider-container');

  containers$.forEach(container$ => {
    const wrapper$ = container$.querySelector('.hero-slider-wrapper');
    const slides$ = Array.from(container$.querySelectorAll('.hero-slide'));
    const prevButton$ = container$.querySelector('.hero-slider-arrow-prev');
    const nextButton$ = container$.querySelector('.hero-slider-arrow-next');
    const dots$ = Array.from(container$.querySelectorAll('.hero-slider-dot'));

    if (slides$.length <= 1) return;

    let currentIndex = 0;
    let autoplayInterval = null;
    let countdownInterval = null;
    const autoplayEnabled = container$.dataset.autoplayEnabled === 'true';
    const autoplayDelay = parseInt(container$.dataset.autoplayDelay) || 5000;

    function updateSlider() {
      const activeDot$ = dots$[currentIndex];
      const activeProgress$ = activeDot$?.querySelector('.hero-slider-dot-progress');

      dots$.forEach((dot) => {
        const progress$ = dot.querySelector('.hero-slider-dot-progress');
        if (progress$) {
          progress$.style.animationName = 'none';
          progress$.style.width = '0';
        }
      });

      wrapper$.dataset.currentSlide = currentIndex;
      dots$.forEach((dot) => dot.classList.remove('active'));

      if (activeDot$) {
        activeDot$.classList.add('active');
        if (!autoplayEnabled) {
          activeDot$.classList.add('paused');
        }
      }

      console.log(`Slide changed to index: ${currentIndex}`);

      void activeProgress$?.offsetWidth;

      if (activeProgress$) {
        activeProgress$.style.animationName = '';
        activeProgress$.style.width = '';
      }

      startCountdown();
    }

    function autoplayNext() {
      currentIndex = (currentIndex + 1) % slides$.length;
      updateSlider();
    }

    function manualNavigate(newIndex) {
      currentIndex = newIndex;
      updateSlider();
      if (autoplayEnabled) {
        clearInterval(autoplayInterval);
        autoplayInterval = setInterval(autoplayNext, autoplayDelay);
        console.log('Autoplay timer reset');
      }
    }

    function startCountdown() {
      clearInterval(countdownInterval);
      const totalSeconds = Math.round(autoplayDelay / 1000);
      let second = 1;
      countdownInterval = setInterval(() => {
        console.log(`segundo ${second}/${totalSeconds} — slide ${currentIndex}`);
        second += 1;
        if (second > totalSeconds) clearInterval(countdownInterval);
      }, 1000);
    }

    function startAutoplay() {
      if (autoplayEnabled && autoplayDelay > 0) {
        clearInterval(autoplayInterval);
        autoplayInterval = setInterval(autoplayNext, autoplayDelay);
        startCountdown();
      }
    }

    if (prevButton$) {
      prevButton$.addEventListener('click', () => {
        manualNavigate((currentIndex - 1 + slides$.length) % slides$.length);
      });
    }

    if (nextButton$) {
      nextButton$.addEventListener('click', () => {
        manualNavigate((currentIndex + 1) % slides$.length);
      });
    }

    dots$.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        manualNavigate(index);
      });
    });

    updateSlider();
    startAutoplay();
  });
});
